// V5 auto-dwell scheduler — starts a countdown when the firefly is
// settled at its anchor; fires once per idle period.

import { useEffect, useRef } from "react";

export type UseFireflyAutoDwellOptions = {
  enabled: boolean;
  /** Per-intent dwell from fireflyIntents (ms at anchor before next move). */
  dwellMs: number;
  /** True when Firefly is settled at anchor (not mid-highlight). */
  anchorDwellReady: boolean;
  /** Pause countdown (e.g. while dragging the anchor). */
  paused: boolean;
  onDwellElapsed: () => void;
};

export function useFireflyAutoDwell({
  enabled,
  dwellMs,
  anchorDwellReady,
  paused,
  onDwellElapsed,
}: UseFireflyAutoDwellOptions): void {
  const onElapsedRef = useRef(onDwellElapsed);
  onElapsedRef.current = onDwellElapsed;

  useEffect(() => {
    if (!enabled || !anchorDwellReady || paused || dwellMs <= 0) return;
    const id = window.setTimeout(() => onElapsedRef.current(), dwellMs);
    return () => window.clearTimeout(id);
  }, [enabled, dwellMs, anchorDwellReady, paused]);
}
